import { Button, Text } from '@mantine/core';
import { useModals } from '@mantine/modals';
import { IconArchive } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { useToggleAssetArchiveStatus } from 'src/Hooks/Mutations/useToggleAssetArchiveStatus';
import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';

import styles from './AdvancedSection.module.scss';

const AdvancedSection = () => {
  const { t } = useTranslation();
  const modals = useModals();
  const assetId = useCurrentAssetId();
  const { mutate: archiveAsset, isLoading: archiveLoading } = useToggleAssetArchiveStatus();

  if (!assetId) return null;

  const handleArchiveClick = () => {
    modals.openConfirmModal({
      title: t('admin.archiveAsset.confirmTitle', 'Archiver le bien'),
      children: (
        <Text size="sm">
          {t(
            'admin.archiveAsset.confirmMessage',
            'Êtes-vous sûr de vouloir archiver ce bien ? Il ne sera plus accessible aux membres.'
          )}
        </Text>
      ),
      labels: {
        confirm: t('admin.archiveAsset', 'Archiver le bien'),
        cancel: t('common.cancel', 'Annuler'),
      },
      confirmProps: { color: 'red' },
      onConfirm: () => archiveAsset({ isArchived: true, assetId }),
    });
  };

  return (
    <div className={styles.dangerZone}>
      <div className={styles.dangerContent}>
        <div className={styles.dangerTitle}>{t('admin.archiveAsset', 'Archiver le bien')}</div>
        <Text size="sm" c="dimmed">
          {t(
            'admin.archiveAsset.description',
            'Le bien et son contenu ne seront plus accessibles aux membres. Vous pourrez le désarchiver à tout moment.'
          )}
        </Text>
      </div>
      <Button
        color="red"
        variant="light"
        leftSection={<IconArchive size={16} />}
        onClick={handleArchiveClick}
        loading={archiveLoading}
      >
        {t('admin.archiveAsset', 'Archiver le bien')}
      </Button>
    </div>
  );
};

export default AdvancedSection;
